import React from 'react';
import * as Sentry from '@sentry/react';
import ErrorPage from '../ErrorPage';
import NotFoundPage from '../NotFoundPage';
import { EmptyOrLoadingState } from '../EmptyOrLoadingState';

export class NotFoundError extends Error {
  name = 'NotFoundError';
  message = '[NotFoundError] Page not found';
}

export default function ErrorBoundary({
  children,
  getIsRecovering,
}: {
  children: React.ReactNode;
  // Using a getter instead of a raw boolean since the source is mutable module state
  getIsRecovering?: () => boolean;
}) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        if (getIsRecovering?.()) {
          return <EmptyOrLoadingState loading />;
        }
        if (error instanceof NotFoundError) {
          return <NotFoundPage />;
        }
        return <ErrorPage />;
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
